import axiosClient from './axiosClient'

const userApi = {
  getUser: () => {
    const url = 'get-user?getGroups=1'
    return axiosClient.get(url)
  },
  getUserById: (userId) => {
    const url = `/get-user?id=${userId}`
    return axiosClient.get(url)
  },
  getNotifications: () => {
    const url = 'list-notifications'
    return axiosClient.get(url)
  },
  updatePayWithUen: (data) => {
    const url = 'pay-with-uen'
    return axiosClient.post(url, data)
  },
  getShortUserById: (id) => {
    const url = `get-short-user-by-id?id=${id}`
    return axiosClient.get(url)
  },
  createNotifications: (data) => {
    const url = '/create-notification'
    return axiosClient.post(url, data)
  },
  createFeedBack: (data) => {
    const url = 'create-feedback'
    return axiosClient.post(url, data)
  },
  updateUser: (data) => {
    const url = 'update-user'
    return axiosClient.patch(url, data)
  },
  changePassword: (data) => {
    const url = 'change-password'
    return axiosClient.patch(url, data)
  },
  getUserInfoById: (id) => {
    const url = `get-user?id=${id}`
    return axiosClient.get(url)
  },
  searchUser: (uid = '') => {
    const url = `search-user?id=${uid}`
    return axiosClient.get(url)
  },
  saveRemindPaymentMessage: (message) => {
    const url = 'create-remind-message'
    return axiosClient.post(url, { message })
  },
  setDefaultRemindPaymentMessage: () => {
    const url = 'set-default-remind-message'
    return axiosClient.patch(url)
  },
  getRemindPaymentMessage: () => {
    const url = 'get-default-remind-message'
    return axiosClient.get(url)
  },
  listUserAddress: () => {
    const url = 'list-user-address'
    return axiosClient.get(url)
  },
  createUserAddress: (data) => {
    const url = 'create-user-address'
    return axiosClient.post(url, data)
  },
  deleteUserAddress: (addressId) => {
    const url = 'delete-user-address'
    return axiosClient.post(url, { addressId })
  },
  updateUserAddress: (data) => {
    const url = 'update-user-address'
    return axiosClient.patch(url, data)
  },
  getListConsolidated: (groupId) => {
    const url = `get-list-consolidated?groupId=${groupId}`
    return axiosClient.get(url)
  },
  createListConsolidated: (groupId, eIds, name) => {
    const url = 'create-list-consolidated'
    return axiosClient.post(url, { groupId, eIds, name })
  },
  deleteListConsolidated: (id) => {
    const url = 'delete-list-consolidated'
    return axiosClient.post(url, { id })
  },
  updateNameConsolidated: (id, name) => {
    const url = 'update-name-consolidated'
    return axiosClient.put(url, { id, name })
  },
  checkUserBlockFeature: () => {
    const url = 'check-user-block-feature'
    return axiosClient.post(url)
  },
}

export default userApi
